module.exports = __webpack_public_path__ + "img/ayaka-nishi_thumbnail.804575e0.jpg";